import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { TicTacToeVideoChatBanner } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function TicTacToeVideoChat() {
  return (
    <>
      <SEO
        title="Tic-Tac-Toe Video Chat - Play X's and O's with Strangers | Talkvee"
        description="Play Tic-Tac-Toe with strangers in a random video chat. Talkvee makes it easy to break the ice with classic games. Join for free and start a match now."
        pathname="/tic-tac-toe-strangers"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Tic-Tac-Toe Video Chat", "item": "https://talkvee.com/tic-tac-toe-strangers" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <TicTacToeVideoChatBanner />
        
        <section className="landing-hero">
          <h1 className="landing-title">Tic-Tac-Toe Video Chat with Strangers</h1>
          <p className="landing-subtitle">
            Looking for something to do while you chat? Challenge your match to a game of Tic-Tac-Toe. It’s the simplest way to turn a random encounter into a fun competition.
          </p>
          <Link to="/" className="tv-cta">🚀 Play Tic-Tac-Toe Now</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Why Users Love Talkvee Games</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
              <h4 style={{margin: '0 0 10px', color: '#1e293b', fontSize: '1.1rem'}}>⭕ Easy to Start</h4>
              <p style={{margin: 0, color: '#475569', lineHeight: '1.6'}}>
                One click to invite your partner. No complex rules, just pure fun during your video call.
              </p>
            </div>
            <div style={{background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
              <h4 style={{margin: '0 0 10px', color: '#1e293b', fontSize: '1.1rem'}}>❌ Global Competition</h4>
              <p style={{margin: 0, color: '#475569', lineHeight: '1.6'}}>
                Every win counts! Rank up and show off your Tic-Tac-Toe skills on the global leaderboard.
              </p>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "How do I play Tic-Tac-Toe on video chat?",
              a: "When you match with someone, click the game icon in the chat interface. Select Tic-Tac-Toe to send an invite!"
            },
            {
              q: "Can I play on my mobile phone?",
              a: "Yes! Talkvee is optimized for mobile browsers, so you can play X's and O's on the go."
            },
            {
              q: "Are there other games available?",
              a: "Yes! You can also challenge strangers to Trivia battles or our famous Try Not To Laugh challenge."
            }
          ]}
        />
      </div>
    </>
  );
}